module.exports = __webpack_public_path__ + "static/media/ic_edit.e9923b80.svg";